import {
  Box,
  Button,
  CardMedia,
  Container,
  Fade,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import {
  arrow,
  money,
  voteBG,
  logoCopy,
  bar8,
  bar1,
  bar2,
  bar3,
  bar4,
  bar5,
  bar6,
  bar7,
  one,
  QRcode,
  splashIcon,
} from "../../Assets";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { listenToAnswer } from "../../services/InteractiveAnswerService";
import { socket } from "../../config/network";
import ImageWithLoader from "../../Components/ImageWithLoader";
import { questions as data } from "./questions";
import SettingsIcon from "@mui/icons-material/Settings";

const VoteShutter = () => {
  const [animate, setAnimate] = useState(true);
  const [animateBox, setAnimateBox] = useState(true);
  const [step, currentStep] = useState(10);
  const [count, setCount] = useState(0);
  const [timer, setTimer] = useState(Date.now() + 30000 * 1);
  const [choice, setChoice] = useState(null);

  const nav = useNavigate();

  const { t, i18n } = useTranslation(["global"]);

  const [searchParams] = useSearchParams();
  const lng = searchParams.get("lng");

  const [activeButton, setActiveButton] = useState(0);
  const [randomObject, setRandomObject] = useState({ question: "" });

  useEffect(() => {
    localStorage.setItem("lng", lng || "en");
  }, [i18n, lng]);

  useEffect(() => {
    if (step <= 7) {
      const randomIndex = Math.floor(Math.random() * data[step]?.length);
      setRandomObject(data[step][randomIndex]);
    }
  }, [step]);

  const next = useCallback(async () => {
    setTimer(Date.now() + 30000 * 1);
    if (step === 8) {
      setCount(0);
    }
    if (step === 9) {
      setAnimate(true);
      setAnimateBox(true);
    }
    currentStep((prev) => {
      if (prev === 0) return 1;
      if (prev === 1) return 2;
      if (prev === 2) return 3;
      if (prev === 3) return 4;
      if (prev === 4) return 5;
      if (prev === 5) return 6;
      if (prev === 6) return 7;
      if (prev === 7) return 8;
      if (prev === 8) return 9;
      if (prev === 9) return 0;
    });
  }, [step]);

  const startTimer = useCallback(() => {
    setTimeout(() => {
      setAnimate(false);
      setAnimateBox(false);
      next();
    }, 3000);
  }, [next]);

  const SequentialAnimation = ({ text }) => {
    const words = text.split(" ");
    const [index, setIndex] = useState(0);

    useEffect(() => {
      if (index >= words.length) return;
      const timeout = setTimeout(() => setIndex((i) => i + 1), 170);
      return () => {
        clearTimeout(timeout);
      };
    }, [setIndex, index, words]);

    const placeholder = words.slice(0, index).join(" ");

    return placeholder;
  };

  const renderer = ({ minutes, seconds }) => {
    return (
      <span>
        {minutes}:{seconds}
      </span>
    );
  };

  const handleClick = useCallback(
    (value) => {
      console.log(value === randomObject?.answer, value, randomObject);
      if (value === randomObject?.answer) {
        setCount((e) => e + 1);
      }
      setChoice(value);
      next();
    },
    [next, randomObject]
  );

  const handleReset = () => {
    next();
    setAnimate(true);
    setAnimateBox(true);
  };

  useEffect(() => {
    socket.auth = {
      token: localStorage.getItem("token"),
    };
    socket.disconnect().connect();
  }, []);

  useEffect(() => {
    listenToAnswer((data) => {
      const res = JSON.parse(data);
      const answer = Number(res?.answer);
      answer > 0 && answer < 5 && handleClick(answer);
    });
    return () => {
      socket.off("webhook_test_uuid");
    };
  }, [handleClick]);

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key >= "1" && event.key <= "4" && step !== 8) {
        setActiveButton(Number(event.key));
        setTimeout(() => {
          const answer = Number(event.key);
          answer > 0 && answer < 5 && handleClick(answer);
          setActiveButton(0);
        }, 200);
      }
    },
    [handleClick]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  step === 10 &&
    setTimeout(() => {
      currentStep(0);
      setTimer(Date.now() + 30000 * 1);
    }, 4000);

  return (
    <>
      <Box
        sx={{
          height: "100vh",
        }}
      >
        <video
          // src="https://vision.shutterstudio.io/bgVedio.mp4"
          width={"100%"}
          loop
          muted
          autoPlay={true}
          style={{
            height: "100%",
            width: "100%",
            position: "fixed",
            zIndex: -3,
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            opacity: "20%",
            objectFit: "cover",
          }}
        ></video>
        <img
          src={voteBG}
          alt=""
          width={"98%"}
          style={{
            height: "98vh",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            position: "absolute",
            zIndex: -2,
            left: "1%",
            top: "1%",
          }}
        />
        <img
          src={money}
          alt=""
          style={{
            borderRadius: "20%",
            width: "10%",
            position: "absolute",
            right: 0,
            top: 0,
          }}
        />
        <img
          src={arrow}
          alt=""
          style={{
            borderRadius: "20%",
            width: "10%",
            position: "absolute",
            left: 15,
            bottom: 0,
          }}
        />
        <Box>
          <Box sx={{ height: "5vh" }}> </Box>

          <Box
            sx={{
              height: "2vh",
              display: "flex",
              justifyContent: "start",
              alignItems: "center ",
              mx: 5,
              position: "relative",
            }}
          >
            <img src={logoCopy} alt="" style={{ width: "300px" }} />{" "}
            <IconButton
              sx={{
                position: "absolute",
                top: 0,
                right: { lg: 140, md: 80, xs: 0 },
              }}
              color="success"
              onClick={() => nav("/setting")}
              size="small"
            >
              <SettingsIcon sx={{ height: "20px" }} />
            </IconButton>
          </Box>
          <Box
            sx={{
              height: "2vh",
              display: "flex",
              justifyContent: "start",
              alignItems: "center ",
              mx: 6,
              my: 2,
              color: "#023D24",
            }}
          >
            <Typography variant="h6" fontWeight={800}>
              {" "}
              previous choice : {choice}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ height: "1vh" }}> </Box>

        <Container maxWidth={"xl"}>
          {step <= 7 && (
            <>
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center ",
                  fontSize: { xs: 25, sm: 30, md: 40 },
                  userSelect: "none",
                  mx: 15,
                }}
                fontWeight={600}
                color={"#023D24"}
              >
                {/* <Countdown
                  date={timer}
                  key={timer}
                  renderer={renderer}
                  onComplete={() => next()}
                /> */}
                <Box sx={{ py: 2 }}></Box>
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    py: { xs: 9, sm: 9, md: 9, lg: 0 },
                  }}
                >
                  <CardMedia
                    image={one}
                    component="img"
                    sx={{
                      width: {
                        sm: "62px",
                        lg: "130px",
                        xs: "32px",
                        md: "100px",
                      },
                      my: 1,
                      mx: 1,
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: { xs: 25, sm: 30, md: 50, lg: 60 },
                      userSelect: "none",
                    }}
                    fontWeight={700}
                    color={"#023D24"}
                  >
                    <SequentialAnimation text={randomObject?.question} />
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    pb: { xs: 5, sm: 5, md: 5, lg: 0 },
                  }}
                >
                  {step === 0 && (
                    <ImageWithLoader
                      src={bar1}
                      alt={""}
                      style={{ width: "70%" }}
                    />
                  )}
                  {step === 1 && (
                    <ImageWithLoader
                      src={bar2}
                      alt={""}
                      style={{ width: "70%" }}
                    />
                  )}
                  {step === 2 && (
                    <ImageWithLoader
                      src={bar3}
                      alt={""}
                      style={{ width: "70%" }}
                    />
                  )}
                  {step === 3 && (
                    <ImageWithLoader
                      src={bar4}
                      alt={""}
                      style={{ width: "70%" }}
                    />
                  )}
                  {step === 4 && (
                    <ImageWithLoader
                      src={bar5}
                      alt={""}
                      style={{ width: "70%" }}
                    />
                  )}
                  {step === 5 && (
                    <ImageWithLoader
                      src={bar6}
                      alt={""}
                      style={{ width: "70%" }}
                    />
                  )}
                  {step === 6 && (
                    <ImageWithLoader
                      src={bar7}
                      alt={""}
                      style={{ width: "70%" }}
                    />
                  )}
                  {step === 7 && (
                    <ImageWithLoader
                      src={bar8}
                      alt={""}
                      style={{ width: "70%" }}
                    />
                  )}
                </Box>
              </Box>

              <Grid
                container
                spacing={8}
                sx={{ mt: { xs: 5, sm: 5, md: 5, lg: 0 } }}
              >
                {randomObject?.chooses?.map((e, i) => (
                  <Grid item xs={12} lg={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => handleClick(e?.id)}
                    >
                      <Box
                        sx={{
                          borderRadius: "50%",
                          width: "30px",
                          height: "30px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          mx: 1,
                          userSelect: "none",
                        }}
                        // bgcolor={"#365A4A"}
                      >
                        <Typography
                          fontWeight={700}
                          variant="h5"
                          // color={"#fff"}
                        >
                          {i + 1} -
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          border: "2.5px solid #A7B136",

                          borderRadius: 5,
                          width: { md: "400px", sm: "300px", xs: "250px" },
                          height: { md: "80px", sm: "65px", xs: "60px" },
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor:
                            activeButton === i + 1 ? "#A7B13688" : "#fff",
                          userSelect: "none",
                          cursor: "pointer",
                        }}
                      >
                        <Typography
                          fontWeight={700}
                          sx={{
                            fontSize: {
                              md: "27px",
                              sm: "17px",
                              xs: "15px",
                            },
                          }}
                          color={"#023D24"}
                          textAlign={"center"}
                        >
                          {e?.value}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </>
          )}
          {step === 8 && (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  justifyContent: "center",
                  height: "90vh",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      py: 6,
                      height: 1,
                    }}
                  >
                    <Typography
                      sx={{ fontSize: { xs: 40, sm: 50, md: 60 }, mx: 1 }}
                      fontWeight={600}
                      color={"#023D24"}
                    >
                      {t("vote.Score")} :
                    </Typography>
                    <Typography
                      sx={{ fontSize: { xs: 40, sm: 50, md: 60 } }}
                      fontWeight={600}
                      color={"#A7B136"}
                    >
                      ({count})
                    </Typography>
                  </Box>
                  <img src={QRcode} alt="" width={"79%"} />
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      pt: 5,
                    }}
                    onClick={() => handleReset()}
                  >
                    <Box
                      sx={{
                        border: "2.5px solid #A7B136",
                        borderRadius: 5,
                        width: { md: "400px", sm: "300px", xs: "250px" },
                        height: { md: "80px", sm: "65px", xs: "60px" },
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#fff",
                        userSelect: "none",
                        cursor: "pointer",
                      }}
                    >
                      <Typography
                        fontWeight={700}
                        sx={{
                          fontSize: {
                            md: "27px",
                            sm: "17px",
                            xs: "15px",
                          },
                        }}
                        color={"#023D24"}
                        textAlign={"center"}
                      >
                        {t("vote.reset")}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </>
          )}
          {step === 9 && (
            <Fade
              direction="down"
              easing="ease-in-out"
              in={animate}
              appear={false}
              timeout={{ exit: 300 }}
              mountOnEnter
              unmountOnExit
              style={{
                transformOrigin: "0 0 0",
                position: "absolute",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                zIndex: 99999,
              }}
            >
              <Box
                sx={{ height: "100vh", backgroundColor: "background.paper" }}
                display="flex"
                alignItems="center"
                justifyContent="center"
                justifyItems="center"
                flexDirection="column"
                position={"relative"}
                overflow={"hidden"}
              >
                <video
                  // src="https://vision.shutterstudio.io/bgVedio.mp4"
                  loop
                  muted
                  autoPlay={true}
                  style={{
                    height: "100%",
                    width: "100%",
                    position: "fixed",
                    zIndex: -1,
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    opacity: "20%",
                    objectFit: "cover",
                  }}
                ></video>
                <Box
                  sx={{
                    width: "1162px",
                    height: "319px",
                    position: "absolute",
                    top: " -241.69px",
                    zIndex: -2,

                    left: "-400px",
                    bgcolor: "#A7B136",
                    transform: "rotate(132.63deg)",
                  }}
                ></Box>
                <Box
                  sx={{
                    width: "1162px",
                    height: "319px",
                    zIndex: -2,
                    position: "absolute",
                    bottom: " -241.69px",
                    right: "-400px",
                    bgcolor: "#A7B136",
                    transform: "rotate(132.63deg)",
                  }}
                ></Box>
                <Fade
                  direction="down"
                  easing="ease-in-out"
                  in={animateBox}
                  appear={true}
                  timeout={{ exit: 300, enter: 1000, appear: 300 }}
                  mountOnEnter
                  unmountOnExit
                  style={{
                    transformOrigin: "0 0 0",
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    justifyItems="center"
                    flexDirection="column"
                  >
                    <img
                      src={splashIcon}
                      alt="pyxiz"
                      height={100}
                      onLoad={startTimer}
                    />
                    <Typography
                      sx={{
                        fontSize: { xs: 25, sm: 30, md: 50, lg: 60 },
                        userSelect: "none",
                        py: 2,
                      }}
                      fontWeight={700}
                      color={"#023D24"}
                    >
                      One Step Closer To Financial Freedom
                    </Typography>
                  </Box>
                </Fade>
              </Box>
            </Fade>
          )}
        </Container>
      </Box>
    </>
  );
};

export default VoteShutter;
